<template>
    <v-dialog
        v-model="dialog"
        persistent
        max-width="290"
    >
        <template v-slot:activator="{ on, attrs }">
            <v-icon small
                class="mr-2"
                v-bind="attrs"
                v-on="on"
            >
                mdi-key-chain-variant
            </v-icon>
        </template>
        <v-card>
            <v-card-title class="headline">
                Reset Password
            </v-card-title>
            <v-card-text>
                <v-form ref="form" v-model="valid">
                    <v-container fluid>
                        <v-row>
                            <v-text-field
                                v-model="password"
                                :append-icon="show1 ? 'mdi-eye' : 'mdi-eye-off'"
                                :rules="[rules.required, rules.length]"
                                :type="show1 ? 'text' : 'password'"
                                label="Password"
                                hint="4 digits PIN"
                                counter
                                @click:append="show1 = !show1"
                            ></v-text-field>
                        </v-row>
                        <v-row>
                            <v-text-field
                                v-model="password2"
                                :append-icon="show2 ? 'mdi-eye' : 'mdi-eye-off'"
                                :rules="[rules.required, rules.length, passwordMatchRule]"
                                :type="show2 ? 'text' : 'password'"
                                label="Re-enter password"
                                hint="4 digits PIN"
                                counter
                                @click:append="show2 = !show2"
                            ></v-text-field>
                        </v-row>
                    </v-container>
                </v-form>
            </v-card-text>
            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn
                    color="red darken-1"
                    text
                    @click="cancel()"
                >
                    Cancel
                </v-btn>
                <v-btn
                    color="blue darken-1"
                    text
                    @click="resetPassword()"
                    :disabled="!valid"
                >
                    Save
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
import axios from "axios";
import { mapActions } from 'vuex';
export default {
    props: ["user"],
    data () {
        return {
            dialog: false,
            show1: false,
            show2: false,
            password: '',
            password2: '',
            valid: false,
            rules: {
                required: value => !!value || 'Required.',
                length: v => v.length == 4 || 'The PIN must be 4 characters long',
            },
        }
    },
    computed: {
        passwordMatchRule() {
            return () => (this.password === this.password2) || `Password doesn't match`
        }
    },
    methods: {
        ...mapActions(["sendMessage"]),
        async resetPassword() {
            this.user.password = this.password;
            this.cancel();

            let response;

            try {
                response = await axios.patch(`/api/User/${this.user.id}/password`, this.user);
            } catch(e) {
                response = null;
            }

            if (response.data) {
                this.sendMessage({
                    color: "success",
                    text: "The user's password has been reset.",
                    timeout: 2000
                });
            } else {
                this.sendMessage({
                    color: "error",
                    text: "Failed to update the user's password. Please, try again.",
                    timeout: 2000
                });
            }
        },
        cancel() {
            this.password = '';
            this.password2 = '';
            this.dialog = false;
        }
    }
}
</script>

<style>

</style>